import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '@hivebrite/design-system/Loader';
import { useAsyncEffect } from '@hivebrite/react-hooks';

import { useEventCartContext } from 'hb-react/shared/apps/Events/contexts/EventCartContext';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useQueryParams } from 'hb-react/shared/hooks/useQueryParams';

const PaymentAccessController = ({ children }) => {
  const query = useQueryParams();

  const cartId = query.cart_id;

  if (cartId) {
    // Ideal and Bancontact payment validation reloads the page with cart_id in url and success status. Data needs to be refetch.
    return (
      <AccessControllerIdealBancontact>
        {children}
      </AccessControllerIdealBancontact>
    );
  }

  return <AccessControllerOthers>{children}</AccessControllerOthers>;
};

export default PaymentAccessController;

const AccessControllerIdealBancontact = ({ children }) => {
  const { data, getCart } = useEventCartContext();
  const query = useQueryParams();

  const cartId = query.cart_id;

  useAsyncEffect(async () => {
    if (cartId) {
      await getCart(cartId);
    }
  }, [cartId]);

  if (cartId && !data) {
    return <Loader size={32} />;
  }

  return children;
};

const AccessControllerOthers = ({ children }) => {
  const navigate = useNavigate();
  const { eventDetailsPageLink } = useEventContext();
  const { data, orderCompleted } = useEventCartContext();
  // User has no access to payment page if cart has no data (reloaded page) or the order is completed (go back after success)
  const hasNoAccess = !data || orderCompleted;

  useEffect(() => {
    if (hasNoAccess) {
      navigate(eventDetailsPageLink);
    }
  }, [hasNoAccess, eventDetailsPageLink, navigate]);

  if (hasNoAccess) {
    return null;
  }

  return children;
};
